import route from "@/components/router/Router"
const routes = [
    {
        path : "factory-carrier-add",
        name : "factory-carrier-add",
        meta : {
            title : "厂房载体-载体录入"
        },
        component: () => import('@/pages/factory/inputCarrier/Index')
    },
    {
        path : "factory-carrier-edit/:id",
        name : "factory-carrier-edit",
        meta : {
            title : "厂房载体-载体录入"
        },
        component: () => import('@/pages/factory/inputCarrier/Index')
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/router/factory/inputcarrier/index.js